import { render, staticRenderFns } from "./EdmUserInfo.vue?vue&type=template&id=82359532&"
import script from "./EdmUserInfo.vue?vue&type=script&lang=js&"
export * from "./EdmUserInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports